<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>TRAZABILIDAD / LOGS DEL SISTEMA</h6>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <!-- Filtros server-side -->
      <div class="row mb-3">
        <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
          <label class="text-xs">Acción</label>
          <select v-model="pagination.action" class="form-control" @change="reloadPaginate(1)">
            <option value="">Todas</option>
            <option v-for="(label, value) in actionLabels" :key="value" :value="value">{{ label }}</option>
          </select>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-12 mb-2">
          <label class="text-xs">Desde</label>
          <input type="date" class="form-control" v-model="pagination.from" @change="reloadPaginate(1)">
        </div>
        <div class="col-lg-2 col-md-3 col-sm-12 mb-2">
          <label class="text-xs">Hasta</label>
          <input type="date" class="form-control" v-model="pagination.to" @change="reloadPaginate(1)">
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 mb-2">
          <label class="text-xs">Buscar</label>
          <input type="text" class="form-control" placeholder="Responsable, descripción..." v-model="pagination.search" @keyup="manualSearch">
        </div>
        <div class="col-lg-2 col-md-6 col-sm-12 mb-2">
          <label class="text-xs">Por página</label>
          <select v-model="pagination.limit" class="form-control" @change="reloadPaginate(1)">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="200">200</option>
          </select>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered table-striped table-sm">
          <thead>
          <tr>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acción</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Descripción</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Realizado por</th>
            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, key) in arrayLogs" :key="key">
            <td>
              <p class="text-xs font-weight-bold mb-0">{{ $filters.formatDateTime(item.created_at) }}</p>
            </td>
            <td>
              <span class="badge badge-sm" :class="badgeClass(item.action)">{{ actionLabels[item.action] || item.action }}</span>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{ item.description }}</p>
            </td>
            <td>
              <p class="text-xs font-weight-bold mb-0">{{ item.performed_by_name || 'Sistema' }}</p>
              <p class="text-xs text-secondary mb-0">{{ item.performed_by_role }}</p>
            </td>
            <td>
              <p class="text-xs text-secondary mb-0" v-if="item.metadata && item.metadata.ip">IP: {{ item.metadata.ip }}</p>
              <p class="text-xs text-secondary mb-0" v-if="item.metadata && item.metadata.email">{{ item.metadata.email }}</p>
              <p class="text-xs text-secondary mb-0" v-if="item.target_name">{{ item.target_name }}</p>
            </td>
          </tr>
          <tr v-if="arrayLogs.length === 0">
            <td colspan="5" class="text-center text-xs text-secondary">Sin registros</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <p class="text-xs font-weight-bold mb-0">total rows: {{ pagination.totalRows }}</p>
        </div>
        <div>
          <v-pagination
              v-model="pagination.page"
              :pages="pagination.pages"
              :range-size="1"
              active-color="#DCEDFF"
              @update:modelValue="reloadPaginate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get} from "@/utils/httpRequest";

export default {
  name: "logs-index",
  data: () => ({
    arrayLogs: [],
    actionLabels: {
      'lead.created': 'Lead creado',
      'lead.updated': 'Lead editado',
      'ip.assigned': 'IP asignada',
      'ip.updated': 'IP actualizada',
      'ip.assigned_bulk': 'IP asignada (masivo)',
      'job_offer.created': 'Oferta creada',
      'agent.created': 'Agente creado',
      'agent.deleted': 'Agente eliminado',
    },
    pagination: {
      searchTimer: null,
      page: 1,
      pages: 0,
      limit: 20,
      search: '',
      action: '',
      from: '',
      to: '',
      totalRows: 0
    }
  }),
  mounted() {
    this.getData();
  },
  methods: {
    badgeClass(action) {
      if (!action) return 'bg-gradient-secondary';
      if (action.startsWith('agent.deleted')) return 'bg-gradient-danger';
      if (action.startsWith('agent')) return 'bg-gradient-dark';
      if (action.startsWith('ip')) return 'bg-gradient-warning';
      if (action.startsWith('job_offer')) return 'bg-gradient-info';
      if (action.startsWith('lead')) return 'bg-gradient-success';
      return 'bg-gradient-secondary';
    },
    reloadPaginate(page) {
      this.pagination.page = page;
      this.getData();
    },
    manualSearch() {
      clearTimeout(this.pagination.searchTimer);
      this.pagination.searchTimer = setTimeout(() => {
        this.reloadPaginate(1);
      }, 800);
    },
    async getData() {
      try {
        const p = this.pagination;
        const {data} = await get(
          `audit-logs?page=${p.page}&limit=${p.limit}&search=${p.search}&action=${p.action}&from=${p.from}&to=${p.to}`
        );
        this.arrayLogs = data.docs;
        this.pagination.totalRows = data.count;
        this.pagination.page = data.page;
        this.pagination.pages = data.pages;
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
</style>
